"use strict";var $export=require("./_export");$export($export.S,"Number",{EPSILON:Math.pow(2,-52)});